import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { MessageSeverity } from '../../enums/message-severity';
import { AppService } from '../../services/app.service';
import { AuthProvider } from '../../enums/auth-provider';
import { SessionService } from '../../services/session/session.service';
import { UserSession } from '../../interfaces/user-session';
import { Session } from '../../models/data/app-core/session';
import { SessionEnvelope } from '../../models/net/envelope/session-envelope';
import { SessionDocument } from '../../models/net/envelope/documents/session-document';
import { CreateResult } from '../../models/net/result/crud/create-result';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-login-callback',
    templateUrl: './login-callback.component.html',
    styleUrls: ['./login-callback.component.css']
})

export class LoginCallbackComponent implements OnInit {

    public subdomain: string = "";

    @HostBinding("class.component-flex-vertical-fill") addClass = true;

    public constructor(private route: ActivatedRoute,
                       private appService: AppService,
                       private authService: AuthService,
                       private sessionService: SessionService) { }

    public ngOnInit(): void {

        const hostname: string = window.location.hostname;
        const parts = hostname.split('.');

        if (parts.length > 1) {

            this.subdomain = parts[0];
        }

        const error = this.route.snapshot.queryParamMap.get("error");

        if (error === "access_denied") {

            this.appService.navigateTo("", this.subdomain);

        } else {

            this.route.params.subscribe((p) => {

                const authProviderName = p["authprovidername"];
                const code = this.route.snapshot.queryParamMap.get("code");

                let authProvider: AuthProvider = AuthProvider.None;

                switch (authProviderName.toLowerCase()) {

                    case "google":

                        authProvider = AuthProvider.Google;
                        break;

                    case "instagram":

                        authProvider = AuthProvider.Instagram;
                        break;
                }

                if (authProvider != AuthProvider.None) {

                    this.appService.IsAppBusy = true;

                    let userSession: UserSession | undefined = undefined;

                    var fqdn: string = this.subdomain + "." + environment.registeredDomain;

                    this.authService.exchangeCodeForToken(fqdn, code, authProvider).subscribe((r) => {

                        if (r != null && r != false) {

                            let message: string = "PKCE code exchanged produced a null token";
                            let messageSeverity: MessageSeverity = MessageSeverity.Warning;
                            const tokenBody: string = r.TokenBody;
                            const userId: number = r.UserId;
                            const userUID: string = r.UserUID;
                            const IdentityProviderUserUID: string = r.IdentityProviderUserUID;
                            const profileImageUrl: string = r.ProfileImageUrl;

                            messageSeverity = MessageSeverity.Success;

                            switch (authProviderName.toLowerCase()) {

                                case "google":

                                    message = "Google PKCE flow completed.  Code " + code?.substr(0, 10) + " exchanged for jwt token " + tokenBody.substr(0, 10);
                                    userSession = this.appService.loggedInGoogle(tokenBody, userId, userUID, IdentityProviderUserUID, profileImageUrl);

                                    break;

                                case "instagram":

                                    message = "Instagram PKCE flow completed.  Code " + code?.substr(0, 10) + " exchanged for opaque token " + tokenBody.substr(0, 10);
                                    userSession = this.appService.loggedInInstagram(tokenBody, userId, userUID, IdentityProviderUserUID, profileImageUrl);

                                    break;
                            }

                            if (userSession) {

                                let session: Session = new Session();
                                let sessionDocument: SessionDocument = new SessionDocument();
                                let sessionEnvelope: SessionEnvelope = new SessionEnvelope(null);

                                session.SessionUID = userSession.sessionId;
                                session.UserUID = userSession.userUID;
                                session.PersonId = -1; // let the session service resolve

                                sessionDocument.Item = session;
                                sessionEnvelope.Document = sessionDocument;

                                this.sessionService.create(sessionEnvelope).subscribe((r: CreateResult | null) => {

                                    if (r) {

                                        if (r.IsSuccess) {

                                            const session: SessionDocument = (r.CreatedEnvelope as SessionEnvelope).Document;

                                            userSession!.serverSession = session;

                                            this.appService.loggedInApp(userSession!);

                                        } else {

                                            this.appService.showDialog(MessageSeverity.Error, "Unable to Create User Session", "Authentication was successful but the app was unable to create a session due to an unexpected error " + r.Message, "OK", "", true, true);
                                        }
                                    }
                                });
                            }

                            this.appService.IsAppBusy = false;
                            this.appService.navigateTo("", "");

                            this.appService.addAppFeedMessage(messageSeverity, message, true);
                        }
                    });
                }
            });
        }
    }
}
